export default function usrMsgraphSignIn(target = '_blank', useSSO = false) {
    // On localhost we have different ports => different sites => different local storages,
    // which is set on one port is not set on another!!!
    const device = this?.deviceType?.toString()?.toUpperCase() || '';
    // for programmer's search, don't delete this comments:
    this.removeStorage('SSO_REDIRECT_TO_MOBILE');
    this.removeStorage('SSO_REDIRECT_TO_SERVIS');
    this.removeStorage('SSO_REDIRECT_TO_DESKTOP');
    this.removeStorage('SSO_REDIRECT_TO_');
    this.setStorage(`SSO_REDIRECT_TO_${device}`, true);

    this.load();
    this.rest.post('msgraphSignIn', {useSSO: useSSO}, (ret) => {
        this.unLoad();
        if (ret?.state || ret?.status) {
            window.open(ret?.redirect_url || ret?.message?.data?.redirect_url, target);
            window.close();
        }
    })
}